import React from 'react'
import { Row, Col } from 'reactstrap';
import FooterContactForm from './FooterContactForm'
import { useState } from 'react'
import ReactHtmlParser from 'react-html-parser';


function Footer() {

    const [footerstyle, setFooterstyle] = useState(global.$footer.style);
    const [hrstyle, setHeaderstyle] = useState(global.$footer.hrstyle);
    const [versionstyle, setVersionstyle] = useState(global.$footer.version.style);

    return (
        <footer style={footerstyle}>
            <div>
                {global.$footer.numberofcols.includes("2") ? (
                    <Row>
                        <Col md={5} className="offset-md-1">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: global.$footer.col1,
                                }}
                            ></div>
                        </Col>
                        <Col md={5}>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: global.$footer.col2,
                                }}
                            ></div>
                        </Col>
                    </Row>
                ) : (
                    ""
                )}
                {global.$footer.numberofcols.includes("3") ? (
                    <Row>
                        <Col md={3} className="offset-md-1">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: global.$footer.col1,
                                }}
                            ></div>
                        </Col>
                        <Col md={4}>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: global.$footer.col2,
                                }}
                            ></div>
                        </Col>
                        <Col md={4}>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: global.$footer.col3,
                                }}
                            ></div>
                        </Col>
                    </Row>
                ) : (
                    ""
                )}
                {global.$contact.footer != null &&
                    global.$contact.footer.enable == true ? (
                    <FooterContactForm />
                ) : (
                    ""
                )}
                <hr style={hrstyle} />
                <Row>
                    <Col md={6}>
                        <div className="copyright offset-md-2">
                            {ReactHtmlParser(global.$footer.copyright)}
                        </div>
                    </Col>
                    <Col md={2}>
                        <div>
                            <p style={versionstyle}>Version:5.2</p>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className="social-icons offset-md-5">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: global.$footer.socialicons,
                                }}
                            ></div>
                        </div>
                    </Col>
                </Row>
            </div>
        </footer>
    )
}

export default Footer